import React, {FunctionComponent, useEffect, useState} from "react";
import {IconBox, IconBoxProps} from "../boxes";
import {BackgroundShape} from "../backgroundShape/backgroundShape.component";
import {SectionWithBackgroundShape} from "../../interfaces/sectionWithBackgroundShape.interface";
import {SectionPadding} from "../../enums";

const styles = require("./iconGrid.component.scss");

interface IconGridProps extends SectionWithBackgroundShape{
    title: string;
    iconComponents: IconBoxProps[];
    sectionPadding: SectionPadding;
}


export const IconGrid: FunctionComponent<IconGridProps> = props => {
    const {title, iconComponents, backgroundShape, sectionPadding} = props;

    return (
        <div className={styles.cardBackground}>
            {!!backgroundShape &&
                <BackgroundShape {...backgroundShape}/>
            }
            <div className={`${styles.cardWrapper} ${styles[sectionPadding]}`}>
                <h2 className={styles.iconGridTitle}>
                    {title}
                </h2>
                <div className={styles.rowContainer}>
                    {iconComponents.map((box, index) =>
                        <IconBox key={index} {...box} />
                    )}
                </div>
            </div>
        </div>
    );
};
